/** The order POST began, but the client did not receive authoritative evidence
 * that the venue accepted or rejected it. This is intentionally not a normal
 * rejection: retrying can duplicate live exposure. */
export class OrderSubmissionUnknownError extends Error {
  readonly code = 'KALSHI_ORDER_STATE_UNKNOWN';

  constructor(message = 'Order result is unknown. Check Open Orders and receipts before trying again.') {
    super(message);
    this.name = 'OrderSubmissionUnknownError';
  }
}
